import React, { useState } from 'react';
import { NICHE_LIST } from '../../../data/diagnostic/niches';
import { FALLBACK_NICHE_QUESTION } from '../../../data/diagnostic/dealModels';

const StepNiche = ({ selectedId, onSelect, showValidation = false }) => {
  const [showFallback, setShowFallback] = useState(false);
  const needsSelection = showValidation && !selectedId;

  return (
    <div className="dg-step">
      <h2 className="dg-step-title">Чем вы занимаетесь?</h2>
      <p className="dg-step-lead">
        Выберите то, что ближе всего. Если сомневаетесь между двумя — берите то, где больше выручки.
      </p>

      {needsSelection ? (
        <p className="dg-step-hint-error" role="alert">
          Выберите нишу, чтобы продолжить
        </p>
      ) : null}

      <div className={`dg-niche-grid${needsSelection ? ' is-invalid' : ''}`}>
        {NICHE_LIST.map((niche) => (
          <button
            key={niche.id}
            type="button"
            className={`dg-niche-card${selectedId === niche.id ? ' is-selected' : ''}`}
            onClick={() => onSelect(niche.id)}
            aria-pressed={selectedId === niche.id}
          >
            <span className="dg-niche-name">{niche.label}</span>
            <span className="dg-niche-examples">{niche.examples}</span>
          </button>
        ))}
      </div>

      {showFallback ? (
        <div className="dg-fallback">
          <p className="dg-fallback-question">{FALLBACK_NICHE_QUESTION.question}</p>
          <div className="dg-fallback-answers">
            {FALLBACK_NICHE_QUESTION.answers.map((answer) => (
              <button
                key={answer.id}
                type="button"
                className="dg-btn dg-btn--ghost"
                onClick={() => {
                  onSelect(answer.nicheId);
                  setShowFallback(false);
                }}
              >
                {answer.label}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <button type="button" className="dg-link-btn" onClick={() => setShowFallback(true)}>
          Не нашёл себя в списке
        </button>
      )}
    </div>
  );
};

export default StepNiche;
